import React from 'react'
import Link from 'gatsby-link'
import githubMark from './github.svg'

function Footer() {
  return (
    <footer className="ph3 ph4-ns pt6 pb3">
      <a className="link b f3 dim black-70 lh-solid" href="mailto:hello@christhierer.com">
        hello@christhierer.com
      </a>
      <p className="f6 db ttu lh-solid pt1">
        <span role="img" aria-label="Copyright">&copy;</span> 2018 Chris Thierer
      </p>
      <div className="mt3">
        <Link className="f6 dib pr2 mid-gray dim" to="/">
          Home
        </Link>
        <a className="f6 dib ph2 mid-gray dim" href="https://www.christhierer.com">
          Portfolio
        </a>
        <a className="f6 dib pl2 mid-gray dim" href="https://www.christhierer.com/resume">
          Résumé
        </a>
      </div>
      <a className="mt4 db" href="https://github.com/cthierer/notebook">
        <img className="mb0" src={githubMark} alt="GitHub logo" />
      </a>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.jsx